import React from "react";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const isOrangeTheme = [
    "dashboard",
    "organization",
    "employment",
    "attendance",
    "usermanagement",
  ].includes(location.pathname.split("/")[1]?.toLowerCase());

  return (
    <footer className="h-10 bg-footerBg border-t border-footerBorder flex items-center px-4">
      <div className="w-full max-w-[1440px] mx-auto flex items-center justify-between text-xs text-footerText font-sans">
        {isOrangeTheme ? (
          <>
            <div>© {new Date().getFullYear()} IAIMS</div>
            <div>
              Developed by{" "}
              <span className="text-primary hover:text-primaryHover font-medium transition-colors">
                Webel Technology Limited (WTL)
              </span>
            </div>
            {/* <div>
              Version 1.0.0
            </div> */}
          </>
        ) : (
          <>
            <div className="flex items-center gap-2">
              <span>© {new Date().getFullYear()}</span>
              <a
                href="https://www.msqube.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors"
              >
                IAIMS
              </a>
              <span>All rights reserved</span>
            </div>

            <div>
              Developed by{" "}
              <a
                href="https://www.msqube.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-primaryHover transition-colors font-medium"
              >
                MSQube Technology Solutions Pvt Ltd
              </a>
            </div>
          </>
        )}
      </div>
    </footer>
  );
};

export default Footer;
